/** biome-ignore-all lint/a11y/noStaticElementInteractions: _ */
/** biome-ignore-all lint/a11y/useKeyWithClickEvents: _ */
"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useCallback, useState } from "react";
import FadeIn from "@/components/FadeIn";
import { useGlobalContext } from "@/components/GlobalStateProvider";
import ListItem from "@/components/ListItem";
import { Vimeo } from "@/components/Vimeo";
import { cn } from "@/lib/utils";
import MobileGallery from "@/components/MobileGallery";
import { RichText } from "@/components/RichText";
import useDevice from "@/components/useDevice";
import { urlForImage } from "@/sanity/lib/image";
import type { CategoryBySlugType } from "@/sanity/query/getCategories";
import type { ProjectType } from "@/sanity/query/project";
import Link from "next/link";
export default function Home() {
  const $ = _c(28);
  const {
    categories,
    selected,
    setSelected,
    setHovered,
    modalOpen
  } = useGlobalContext();
  const effectiveCategory = selected.category;
  const effectiveProject = selected.project;
  const [homage, setHomage] = useState(true);
  let t0;
  if ($[0] !== setHovered || $[1] !== setSelected) {
    t0 = () => {
      setSelected({
        category: null,
        project: null
      });
      setHovered({
        category: null,
        project: null
      });
    };
    $[0] = setHovered;
    $[1] = setSelected;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleReset = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("w-screen basis-4/5 px-3.25 py-36 lg:flex lg:items-stretch lg:px-13.75 lg:py-13.75 lg:*:mr-3.25 lg:*:inline-flex lg:*:flex-col lg:*:items-start", "grid grid-cols-2", "mx-auto max-w-200 lg:mx-0 lg:max-w-none");
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== categories || $[5] !== effectiveCategory || $[6] !== homage) {
    t2 = <CategoryList homage={homage} categories={categories} effectiveCategory={effectiveCategory} />;
    $[4] = categories;
    $[5] = effectiveCategory;
    $[6] = homage;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== effectiveCategory || $[9] !== effectiveProject) {
    t3 = effectiveCategory && <ProjectList category={effectiveCategory} effectiveProject={effectiveProject} />;
    $[8] = effectiveCategory;
    $[9] = effectiveProject;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== effectiveProject) {
    t4 = effectiveProject && <ProjectDetails />;
    $[11] = effectiveProject;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== handleReset || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div className={t1} onClick={handleReset}>{t2}{t3}{t4}</div>;
    $[13] = handleReset;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== homage || $[19] !== selected.category || $[20] !== selected.project) {
    t6 = !(selected.project || selected.category) && <div className="basis-1/6 px-13.75 lg:px-22.25"><button type="button" className="text-not-active hover:text-active focus:text-active mt-10 w-fit cursor-pointer p-0 italic focus:outline-none" onClick={() => setHomage(!homage)}>{homage ? "Homage" : "Standard Issue"}</button></div>;
    $[18] = homage;
    $[19] = selected.category;
    $[20] = selected.project;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== modalOpen) {
    t7 = modalOpen && <ModalView />;
    $[22] = modalOpen;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t5 || $[25] !== t6 || $[26] !== t7) {
    t8 = <main className="flex h-screen w-screen flex-col overflow-x-hidden overflow-y-auto">{t5}{t6}{t7}</main>;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}

// ============================================================================
// Category List
// ============================================================================

function CategoryList(t0) {
  const $ = _c(13);
  const {
    categories,
    homage,
    effectiveCategory
  } = t0;
  const {
    setHovered,
    setSelected
  } = useGlobalContext();
  let t1;
  if ($[0] !== categories || $[1] !== effectiveCategory || $[2] !== homage || $[3] !== setHovered || $[4] !== setSelected) {
    let t2;
    if ($[6] !== effectiveCategory || $[7] !== homage || $[8] !== setHovered || $[9] !== setSelected) {
      t2 = category => <ListItem className="w-fit!" key={category.slug} active={category === effectiveCategory} onMouseEnter={() => setHovered({
        category,
        project: null
      })} onClick={e => {
        e.stopPropagation();
        setSelected({
          category,
          project: null
        });
        setHovered({
          category,
          project: null
        });
      }}>{homage ? category.title : category.title2}</ListItem>;
      $[6] = effectiveCategory;
      $[7] = homage;
      $[8] = setHovered;
      $[9] = setSelected;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    t1 = categories.map(t2);
    $[0] = categories;
    $[1] = effectiveCategory;
    $[2] = homage;
    $[3] = setHovered;
    $[4] = setSelected;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[11] !== t1) {
    t2 = <ul className="col-span-1 lg:w-55 lg:min-w-55">{t1}</ul>;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}

// ============================================================================
// Project List
// ============================================================================

function ProjectList(t0) {
  const $ = _c(14);
  const {
    category,
    effectiveProject
  } = t0;
  const {
    setHovered,
    setSelected
  } = useGlobalContext();
  let t1;
  if ($[0] !== setHovered || $[1] !== setSelected) {
    t1 = e => {
      e.preventDefault();
      e.stopPropagation();
      setSelected(_temp);
      setHovered(_temp2);
    };
    $[0] = setHovered;
    $[1] = setSelected;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleContainerClick = t1;
  let t2;
  if ($[3] !== category || $[4] !== effectiveProject || $[5] !== setHovered || $[6] !== setSelected) {
    t2 = category.projects?.map(project => <ListItem key={project.slug.current} active={project === effectiveProject} onMouseEnter={() => {
      setHovered({
        category,
        project
      });
    }} onClick={e_0 => {
      e_0.stopPropagation();
      e_0.preventDefault();
      setSelected({
        category,
        project
      });
    }}>{project.title}</ListItem>);
    $[3] = category;
    $[4] = effectiveProject;
    $[5] = setHovered;
    $[6] = setSelected;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== category.id || $[9] !== t2) {
    t3 = <FadeIn show={true} key={category.id}>{t2}</FadeIn>;
    $[8] = category.id;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== handleContainerClick || $[12] !== t3) {
    t4 = <ul className="col-span-1 lg:w-55 lg:min-w-55" onClick={handleContainerClick}>{t3}</ul>;
    $[11] = handleContainerClick;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}

// ============================================================================
// Project Details
// ============================================================================
function _temp2() {
  return {
    category: null,
    project: null
  };
}
function _temp() {
  return {
    category: null,
    project: null
  };
}
function ProjectDetails() {
  const $ = _c(31);
  const {
    setModalOpen,
    setModalIndex,
    selected
  } = useGlobalContext();
  const effectiveProject = selected.project;
  const {
    dpr
  } = useDevice();
  let T0;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== dpr || $[1] !== effectiveProject || $[2] !== setModalIndex || $[3] !== setModalOpen) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const toShow = effectiveProject ? [effectiveProject.thumbnail, ...(effectiveProject.content ?? [])] : [];
      let t5;
      if ($[10] !== setModalIndex || $[11] !== setModalOpen) {
        t5 = (e, index) => {
          e.preventDefault();
          e.stopPropagation();
          setModalIndex(index);
          setModalOpen(true);
        };
        $[10] = setModalIndex;
        $[11] = setModalOpen;
        $[12] = t5;
      } else {
        t5 = $[12];
      }
      const handleImageClick = t5;
      const handleSectionClick = _temp3;
      if (!effectiveProject) {
        t4 = null;
        break bb0;
      }
      T0 = FadeIn;
      let t6;
      if ($[13] !== effectiveProject.description) {
        t6 = effectiveProject.description ?? [];
        $[13] = effectiveProject.description;
        $[14] = t6;
      } else {
        t6 = $[14];
      }
      let t7;
      if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
          marks: {
            link: _temp5
          },
          block: _temp7
        };
        $[15] = t7;
      } else {
        t7 = $[15];
      }
      if ($[16] !== t6) {
        t2 = <div className="col-span-2 mx-auto my-13.75 w-full lg:pr-10.5 lg:col-span-1 lg:mx-0 lg:my-0 lg:w-94.25" onClick={handleSectionClick}><RichText data={t6} components={t7} /></div>;
        $[16] = t6;
        $[17] = t2;
      } else {
        t2 = $[17];
      }
      if ($[18] !== dpr || $[19] !== effectiveProject.thumbnail || $[20] !== effectiveProject.title || $[21] !== handleImageClick) {
        t3 = effectiveProject.thumbnail ? <section className="mr-0! hidden w-55 flex-col items-end! lg:flex"><Image id={effectiveProject.thumbnail.id} width={220} height={220 / effectiveProject.thumbnail.metadata.dimensions.aspectRatio} src={urlForImage(effectiveProject.thumbnail.url).width(220).dpr(dpr).url()} alt={effectiveProject.title} placeholder="blur" blurDataURL={effectiveProject.thumbnail.metadata.lqip} unoptimized={true} onClick={e_2 => {
            handleImageClick(e_2, 0);
          }} className={cn("min-w-55 cursor-pointer")} /></section> : null;
        $[18] = dpr;
        $[19] = effectiveProject.thumbnail;
        $[20] = effectiveProject.title;
        $[21] = handleImageClick;
        $[22] = t3;
      } else {
        t3 = $[22];
      }
      t0 = "col-span-2 flex flex-col gap-3.25 lg:hidden!";
      t1 = toShow?.map((asset, index_0) => {
        if (!asset) {
          return null;
        }
        if (asset._type !== "film") {
          const img = asset;
          return <Image key={img.url} alt={effectiveProject.title} src={urlForImage(img.url).width(800).dpr(dpr).url()} onClick={e_3 => handleImageClick(e_3, index_0)} unoptimized={true} blurDataURL={img.metadata.lqip} placeholder="blur" width={800} height={800 / img.metadata.dimensions.aspectRatio} className="mx-auto cursor-pointer object-contain object-center" style={{
            aspectRatio: img.metadata.dimensions.aspectRatio
          }} />;
        } else {
          if (asset._type === "film") {
            return <Vimeo key={asset.vimeo} value={asset.vimeo} title={effectiveProject.title} />;
          } else {
            return null;
          }
        }
      });
    }
    $[0] = dpr;
    $[1] = effectiveProject;
    $[2] = setModalIndex;
    $[3] = setModalOpen;
    $[4] = T0;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    T0 = $[4];
    t0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[23] !== t0 || $[24] !== t1) {
    t5 = <section className={t0}>{t1}</section>;
    $[23] = t0;
    $[24] = t1;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== T0 || $[27] !== t2 || $[28] !== t3 || $[29] !== t5) {
    t6 = <T0>{t2}{t3}{t5}</T0>;
    $[26] = T0;
    $[27] = t2;
    $[28] = t3;
    $[29] = t5;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  return t6;
}
function _temp7(t0) {
  const {
    children: children_0,
    value: value_0
  } = t0;
  const isEmpty = value_0.children?.every(_temp6);
  if (isEmpty) {
    return <br />;
  }
  return <p className="block wrap-break-word whitespace-normal">{children_0}</p>;
}
function _temp6(child) {
  return !child.text?.trim();
}
function _temp5(t0) {
  const {
    children,
    value
  } = t0;
  const rel = !value.href.startsWith("/") ? "noreferrer noopener" : undefined;
  return <Link href={value.href} rel={rel} target="_blank" onClick={_temp4} className="text-not-active hover:text-active focus:text-active cursor-pointer underline-offset-auto focus:outline-none">{children}</Link>;
}
function _temp4(e_1) {
  e_1.stopPropagation();
}
function _temp3(e_0) {
  e_0.preventDefault();
  e_0.stopPropagation();
}
function ModalView() {
  const $ = _c(2);
  const {
    isTouchDevice,
    width
  } = useDevice();
  const isDesktop = width >= 1024;
  const behavior = isTouchDevice || !isDesktop ? "smooth" : "instant";
  let t0;
  if ($[0] !== behavior) {
    t0 = <MobileGallery behavior={behavior} />;
    $[0] = behavior;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}